import App from './App';
import { ProviderProps } from 'edocatbase/Global';

const { Provider } = window.reactRedux;
const { ThemeProvider } = window.Edocat.Utils;

export default class RootComponent extends React.PureComponent<ProviderProps> {
  render() {
    return (
      <Provider store={this.props.store}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </Provider>
    );
  }
}
